/** Username / password helpers for native auth. */

export const USERNAME_RULES_MESSAGE =
  'Username must be lowercase letters, numbers, underscore (_), or hyphen (-) only. Spaces are not allowed.';

export const USERNAME_RULES = [
  'Lowercase letters only (a–z)',
  'Numbers, underscore (_), and hyphen (-) allowed',
  'No spaces',
  'Maximum 64 characters',
];

export const PASSWORD_RULES_MESSAGE =
  'Password must be at least 6 characters long, contain at least one letter, and at least one number.';

export const PASSWORD_RULES = [
  'At least 6 characters',
  'At least one letter',
  'At least one number',
];

export function normalizeMobileInput(value) {
  let digits = (value || '').replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) {
    digits = digits.slice(2);
  }
  return digits;
}

export function normalizeUsername(value) {
  const raw = (value || '').trim();
  const mobile = normalizeMobileInput(raw);
  if (/^\d{10}$/.test(mobile)) {
    return mobile;
  }
  return raw;
}

export function isTenDigitMobile(value) {
  return /^\d{10}$/.test(normalizeUsername(value));
}

/** e.g. "New Staff" → "new_staff" */
export function suggestUsernameFromName(name) {
  return (name || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_-]/g, '')
    .replace(/[_-]{2,}/g, '_')
    .replace(/^[_-]+|[_-]+$/g, '')
    .slice(0, 64);
}

export function validateManagementUsername(username) {
  const uname = (username || '').trim();
  if (!uname) return 'Username is required';
  if (uname.length > 64) return 'Username must be at most 64 characters';
  if (uname !== uname.toLowerCase()) return 'Username must be lowercase';
  if (/\s/.test(uname)) return 'Username cannot contain spaces';
  if (!/^[a-z0-9_-]+$/.test(uname)) return USERNAME_RULES_MESSAGE;
  return null;
}

export function validatePasswordRules(password) {
  const errors = [];
  if (!password || password.length < 6) {
    errors.push('Password must be at least 6 characters long');
  }
  if (!/[a-zA-Z]/.test(password || '')) {
    errors.push('Password must contain at least one letter');
  }
  if (!/[0-9]/.test(password || '')) {
    errors.push('Password must contain at least one number');
  }
  return errors;
}

const PREFILL_KEY = 'renttick_prefill_username';

export function consumePrefillUsername(search) {
  const params = new URLSearchParams(search);
  const fromUrl = params.get('username');
  if (fromUrl) {
    const normalized = normalizeUsername(fromUrl);
    sessionStorage.setItem(PREFILL_KEY, normalized);
    params.delete('username');
    return { username: normalized, cleanedSearch: params.toString() };
  }
  const stored = sessionStorage.getItem(PREFILL_KEY);
  return { username: stored || '', cleanedSearch: params.toString() };
}

export function clearPrefillUsername() {
  sessionStorage.removeItem(PREFILL_KEY);
}
